import { IAction, ActionType } from "../actions/actiontype";
import * as _ from 'lodash';
import * as Classes from "../../../classes/index"
import { updateArray } from "../../../helpers/index";
import { IWaiverApiText, defaultWaiverApiText } from "../../../classes/index";

export interface ApiModel {
    waitingForSubmitionResponse: number;
    submissionSent: boolean;
    submitionResponse: string;
    submitionError: boolean;
    waitingForWaiverTextResponse: boolean;
    waiverText: IWaiverApiText;
    waitingForDepositAmountResponse: boolean;
    depositAmount: string;
    waitingForShowAllergiesRadio: boolean;
    showAllergiesRadio: boolean;
    waitingForCampOptions: boolean;
    campOptions: Array<Classes.IOption>;
}

export const defaultApiModel: ApiModel = {
    waitingForSubmitionResponse: 0,
    submissionSent: false,
    submitionResponse: null,
    submitionError: false,
    waitingForWaiverTextResponse: false,
    waiverText: defaultWaiverApiText,
    waitingForDepositAmountResponse: false,
    depositAmount: "",
    waitingForShowAllergiesRadio: false,
    showAllergiesRadio: false,
    waitingForCampOptions: false,
    campOptions: [{ value: "", text: "Please select a camp" }]
};

export default function apiReducer(state: ApiModel = defaultApiModel, action: IAction) {
    switch (action.type) {
        case ActionType.CAMP_OPTIONS_REQUEST: {
            return _.assign({}, state, { waitingForCampOptions: true });
        }

        case ActionType.CAMP_OPTIONS_RESPONSE: {
            return _.assign({}, state, { waitingForCampOptions: false, campOptions: action.value });
        }

        case ActionType.WAIVER_TEXT_REQUEST: {
            return _.assign({}, state, { waitingForWaiverTextResponse: true });
        }

        case ActionType.FORM_RESPONSE: {
            return _.assign({}, state, { waitingForSubmitionResponse: state.waitingForSubmitionResponse - 1, submitionResponse: action.value });
        }

        case ActionType.FORM_ERROR: {
            return _.assign({}, state, {
                waitingForSubmitionResponse: state.waitingForSubmitionResponse - 1,
                submitionError: true,
                submissionSent: false
            });
        }

        case ActionType.WAIVER_TEXT_RECEIVED: {
            return _.assign({}, state, { waitingForWaiverTextResponse: false, waiverText: action.value });
        }

        case ActionType.SUBMIT_FORM: {
            return _.assign({}, state, { waitingForSubmitionResponse: state.waitingForSubmitionResponse + 1, submitionResponse: "", submitionError: false, submissionSent: true });
        }

        case ActionType.DEPOSIT_AMOUNT_REQUEST: {
            return _.assign({}, state, { waitingForDepositAmountResponse: true });
        }

        case ActionType.DEPOSIT_AMOUNT_RECEIVED: {
            return _.assign({}, state, { waitingForDepositAmountResponse: false, depositAmount: action.value });
        }

        case ActionType.SHOW_ALLERGIES_RADIO_REQUEST: {
            return _.assign({}, state, { waitingForShowAllergiesRadio: true });
        }

        case ActionType.SHOW_ALLERGIES_RADIO_RECEIVED: {
            return _.assign({}, state, { waitingForShowAllergiesRadio: false, showAllergiesRadio: action.value });
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/camp-sign-up/redux/reducers/api-reducer.ts